/* eslint-disable import/prefer-default-export */
export function createGetColorSchemeSelector(selector) {
  return function getColorSchemeSelector(colorScheme) {
    if (selector === 'media') {
      if (process.env.NODE_ENV !== 'production') {
        if (colorScheme !== 'light' && colorScheme !== 'dark') {
          console.error("MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '".concat(colorScheme, "'."));
        }
      }
      return "@media (prefers-color-scheme: ".concat(colorScheme, ")");
    }
    if (selector) {
      if (selector.startsWith('data-') && !selector.includes('%s')) {
        return "[".concat(selector, "=\"").concat(colorScheme, "\"] &");
      }
      if (selector === 'class') {
        return ".".concat(colorScheme, " &");
      }
      if (selector === 'data') {
        return "[data-".concat(colorScheme, "] &");
      }
      return "".concat(selector.replace('%s', colorScheme), " &");
    }
    return '&';
  };
}